// code for checking the token vlidation for admin
import React from "react";
import { Navigate, Outlet } from "react-router-dom";

const PrivateRoute = () => {
  const token = localStorage.getItem("adminToken"); // Check if the token exists

  return token ? <Outlet /> : <Navigate to="/adminLogin" replace />;
};

export default PrivateRoute;
